import { emitEventForBenefitPropertyChange, emitEventForFieldChange } from "global/EmitEvent/Delta";
import { bcbs_groupconfigurationsnapshot } from "model/CRM";
import { IAccountsReceivable, IBenefit, IFeesAndPremiums, IFlexibleField, IFlexibleFieldSet, IGroupConfigurationConfig, IGroupConfigurationData, IGroupNumber, INonStandard, IPlan, IStopLoss } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";

/**
 * Emits missing
 */

export enum EGroupCollectIntegrationStatus {
    /** for cloned cases by group collect, we remove emit events and remit */
    EUntracked = "untracked",

    /** for modified cases by Group Collect, we just find the missing emit events and emit */
    EModified = "modified",
}

export class GroupCollectEmitEventTransformer extends BaseJsonTransformer {
    readonly release: IGroupConfigurationConfig;
    readonly snapshot: bcbs_groupconfigurationsnapshot;
    readonly status: EGroupCollectIntegrationStatus;

    constructor(
        release: IGroupConfigurationConfig,
        snapshot: bcbs_groupconfigurationsnapshot,
        status: EGroupCollectIntegrationStatus,
    ) {
        super();
        this.release = release;
        this.snapshot = snapshot;
        this.status = status;
    }

    async before(json: IGroupConfigurationData): Promise<void> {
    }

    async transformGroupConfiguration(json: IGroupConfigurationData): Promise<void> {
        this.processFields(json.fields);
    }

    async transformAttributeSet(attributeSet: IFlexibleFieldSet, context: ITransformContext): Promise<boolean | void> {
        this.processFields(attributeSet.fields);
    }

    async transformNonStandard(nonStandard: INonStandard, context: ITransformContext): Promise<boolean | void> {
        this.processFields(nonStandard.fields);
    }

    async transformBenefit(benefit: IBenefit): Promise<boolean | void> {
        emitEventForBenefitPropertyChange(this.snapshot, null, benefit, true);

        this.processFields(benefit.fields, benefit);
    }

    async transformAccountsReceivable(accountsReceivable: IAccountsReceivable): Promise<boolean | void> {
        this.processFields(accountsReceivable.fields);
    }

    async transformStopLoss(stopLoss: IStopLoss): Promise<boolean | void> {
        this.processFields(stopLoss.fields);
    }

    async transformFeesAndPremium(feesAndPremium: IFeesAndPremiums): Promise<boolean | void> {
        this.processFields(feesAndPremium.fields);
    }

    async transformPlan(plan: IPlan): Promise<boolean | void> {
        this.processFields(plan.fields);
    }

    async transformGroupNumber(groupNumber: IGroupNumber): Promise<boolean | void> {
        this.processFields(groupNumber.fields);
    }

    async after(json: IGroupConfigurationData): Promise<void> {

    }

    processFields(sourceFields: IFlexibleField[], benefit?: IBenefit): void {
        sourceFields.forEach(field => {

            const configAttribute = this.release.cache.map_bcbs_config_attribute[field.configRef.id];

            field.values.forEach(value => {

                // if untracked, we need to disassociate the cloned version of emits so we can emit new ones.
                if (this.status === EGroupCollectIntegrationStatus.EUntracked)
                    delete value.emitRefId;


                if (value.value && !value.emitRefId)
                    if (
                        (configAttribute?.bcbs_isemiteventonclone && this.status === EGroupCollectIntegrationStatus.EUntracked) ||
                        
                        // in case if we need to also trigger the change ones as well
                        // (configAttribute.bcbs_isemiteventonclone && this.status === EGroupCollectIntegrationStatus.EModified) || 
                        
                        (configAttribute?.bcbs_isemitevent && this.status === EGroupCollectIntegrationStatus.EModified)
                    ) {

                        const emitTracker = emitEventForFieldChange(
                            this.release,
                            this.snapshot,
                            benefit ?? null,
                            field,
                            value,
                            value.value,
                            this.status === EGroupCollectIntegrationStatus.EUntracked, // if its untracked, its for clone process
                            true // always ignore delta, if updated by group collect and it is missing emitRefId, then its a change
                        );

                        // TODO ask HVu to make sure, update rounds coming from group collect have their EmitRefId removed, so it would trigger a change.
                        // one problem is previous value will be lost

                        if (emitTracker)
                            value.emitRefId = emitTracker?.bcbs_groupconfigurationsnapshoteventid;
                    }
            });
        });
    }
}
